











































import PassivePopup from "@/components/PassivePopup.vue";
import { onMounted, ref } from "@vue/composition-api";
import Vue from "vue";
import { UseModal } from "../../modal";
import * as api from "./api";
import { OrgImpersonateStatus } from "./api";
import SupportMenu from "./SupportMenu.vue";
export default Vue.extend({
  components: { SupportMenu, PassivePopup },
  setup() {
    const show_menu = ref(false);
    const impersonation_status = ref<OrgImpersonateStatus>("None");

    const on_support_clicked = () => {
      window.open("https://docs.cognni.ai/en/", "_blank");
    };

    const approve_access = async () => {
      const res = await api.approve_impersonation();
      if (res.success) {
        impersonation_status.value = "Open";
      }
    };

    const reject_access = async () => {
      const res = await api.reject_impersonation();
      if (res.success) {
        impersonation_status.value = "None";
      }
    };

    const provide_access = async () => {
      const res = await api.provide_impersonation();
      if (res.success) {
        impersonation_status.value = "Open";
      }
    };

    const revoke_access = async () => {
      const is_remove_res = await UseModal().showSimple({
        title: "Remove Support Access",
        desc:
          "This will remove the ability of Cognni Support </br> to login to your organization in order to help",
        is_destructive: true,
        cancelBtnText: "Cancel",
        submitBtnText: "Revoke access",
      });
      if (is_remove_res.type == "success") {
        const res = await api.revoke_impersonation();
        if (res.success) {
          impersonation_status.value = "None";
        }
      }
    };

    const view_support_history = async () => {
      console.log("view support history");
    };

    const on_action = (action: string) => {
      switch (action) {
        case "site":
          on_support_clicked();
          break;
        case "approve_access":
          approve_access();
          break;
        case "reject_access":
          reject_access();
          break;
        case "provide_access":
          provide_access();
          break;
        case "revoke_access":
          revoke_access();
          break;
        case "history":
          view_support_history();
          break;
      }
    };

    onMounted(async () => {
      const res = await api.get_impersonation_status();
      if (res.success) {
        impersonation_status.value = res.value;
      }
      setInterval(async () => {
        const res = await api.get_impersonation_status();
        if (res.success) {
          impersonation_status.value = res.value;
        }
      }, 60_000);
    });
    return {
      on_action,
      show_menu,
      impersonation_status,
    };
  },
});
